import { Base } from '../../components/base-component';

import { AnalyticsService } from '../../services/analytics.service';

import './form-item-bl-apply-now.component.scss';

import * as $ from 'jquery';

export class FormItemBlApplyNow extends Base {

	// form
	form: HTMLFormElement;
	steps: HTMLFormElement[];

	// form sections
	formLoader: Element;
	formFields: Element;
	formThankyou: Element;
	timeout: any;
	customHeading: HTMLFormElement;

	// inputs
	entityType: HTMLFormElement;
	southAfricanIdField: HTMLFormElement;
	businessFields: HTMLFormElement[];
	jointFields: HTMLFormElement[];
	applicantAdd: HTMLFormElement;
	applicantRem: HTMLFormElement[];

	// buttons
	buttonSubmit: Element;
	stepButtons: Element[];

	// wizard count
	wizardCount: Element;
	bulletContainer: Element;
	totalSteps: Element;

	// hidden
	hidLeadId: any;
	hidProduct: any;
	hidCallMeBackModalId: any;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.formLoader = this.element.querySelector(".form__loader--container");
		this.formFields = this.element.querySelector(".form__fields--container");
		this.formThankyou = this.element.querySelector(".form__thankyou--container");
		this.customHeading = this.element.querySelector(".customHeading");

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.steps = Array.from(this.element.querySelectorAll(".bl-apply-now__steps--step[data-step]"));
		this.buttonSubmit = this.element.querySelector('.js_step-submit-button');
		this.stepButtons = Array.from(this.element.querySelectorAll(".js_step-button"));

		this.hidLeadId = this.form.querySelector('input[name=leadId]');
		this.hidProduct = this.form.querySelector('input[name=product]');

		this.entityType = this.element.querySelector(".js-apply-now-entity-type");
		this.businessFields = Array.from(this.element.querySelectorAll(".js-hs-apply-now-vissible-business"));
		this.southAfricanIdField = this.element.querySelector('.js-hs-apply-now-vissible-id');

		this.wizardCount = this.element.querySelector(".bl-apply-now__counter--count");
		this.bulletContainer = this.element.querySelector(".bl-apply-now__bullets");

		this.totalSteps = this.element.querySelector('input[name="total-steps"]');
		this.totalSteps.nodeValue = this.steps.length.toString();
		this.showStep(1);

		if (this.entityType) {
			this.updateForm(this.entityType.value);
		}
	}

	bindEvents() {

		if (this.buttonSubmit) {
			this.buttonSubmit.addEventListener('click', (event) => {
				const formFields: any = this.form.querySelectorAll('input, select, textarea');
				const validation = this.validationService.validate(formFields);
				const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
				if (valid.length == 0) {
					this.actionForm(this.form);
				}
			});
		}

		if (this.stepButtons.length) {
			this.stepButtons.map((item) => item.addEventListener('click', (event) => {
				const _event: any = event.currentTarget;
				const _currentStep = _event.closest(".bl-apply-now__steps--step");
				let _steps = Array.from(this.element.querySelectorAll(".bl-apply-now__steps--step"));
				if (!_currentStep.classList.contains("bl-apply-now__steps--hidden")) {
					const formFields: any = _currentStep.querySelectorAll('input, select, textarea');
					const validation = this.validationService.validate(formFields);
					const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
					if (valid.length == 0) {
						this.showNextStep(event);
					}
				}
			}));
		}

		if (this.entityType) {
			this.entityType.addEventListener('change', (event) => {
				this.updateForm(this.entityType.value);
			});
		}

		// This adds slashes to the business registration number
		let businessReg = this.element.querySelector(".js-hs-apply-now-vissible-business");

		if (businessReg) {

			businessReg.addEventListener('input', (event: any) => {
				if ((event.inputType != "deleteContentBackward") && (event.inputType != "deleteContentForward")) {
					let reg = event.target.value;
					event.target.value = this.formatBusinessReg(reg);
				}
			});

			businessReg.addEventListener('blur', (event: any) => {
				let reg = event.target.value;
				event.target.value = this.formatExpression(reg);
			});
		}

		// Reset the form
		this.form.addEventListener('custom_form_reset_event', (e) => {
			this.showStep(1);

			// This will reset step 2
			if (this.entityType) {
				this.updateForm(this.entityType.value);
			}

		}, false);
	}

	formatBusinessReg(event) {
		const _stringLength: number = parseFloat(event.length);
		const _newLength: number = (_stringLength - 1);
		const _check = event.substring(_newLength);
		const reg = new RegExp('^[0-9]+$');
		if (reg.test(_check)) {
			if (event.length == 4) {
				event = event += "/";
			} else if (event.length == 11) {
				event = event += "/";
			} else if (event.length > 14) {
				event = event.substring(0, 14);
			}
		}
		else {
			return event.substring(0, _newLength);
		}

		return event;
	}

	formatExpression(inputText: string) {
		let _check = inputText.split('/');
		if (_check.length > 1) {
			let _valid1 = true;
			let _valid2 = true;
			let _valid3 = true;
			if (_check.length == 3) {
				const _seg1 = new RegExp('^/d{4}$');
				const _seg2 = new RegExp('^/d{6}$');
				const _seg3 = new RegExp('^/d{2}$');
				if (_seg1.test(_check[0])) {
					_valid1 = false;
				}
				if (_seg2.test(_check[1])) {
					_valid2 = false;
				}
				if (_seg3.test(_check[2])) {
					_valid3 = false;
				}
				if (_valid1 && _valid2 && _valid3) {
					return inputText;
				} else {
					return '';
				}
			} else {
				return '';
			}
		} else if (inputText.length >= 12) {
			let _firstcharacters = inputText.substring(0, 4);
			let _secondCharacters = inputText.substring(5, 10);
			let _thirdCharacters = inputText.substring(11, 13);
			return _firstcharacters + '/' + _secondCharacters + '/' + _thirdCharacters;
		}
		return '';
	}

	showStep(stepId) {
		const _currentstep = this.element.querySelector("[data-step='" + stepId + "']");
		const _heading: any = _currentstep.getAttribute("data-heading");
		if (_heading) {
			const _h3Heading = this.customHeading.querySelector("h3");
			_h3Heading.innerHTML = _heading;
		}
		const _listItems = document.createElement('ul');
		_listItems.classList.add("bl-apply-now__bullets-container");
		if (this.steps) {
			this.steps.forEach((element, index) => {
				const _step = element.getAttribute("data-step");
				const _listItem = document.createElement('li');
				if ((parseFloat(_step) == stepId)) {
					element.classList.remove("bl-apply-now__steps--hidden");
					_listItem.classList.add("bl-apply-now__bullets-container--bullet", "bl-apply-now__bullets-container--bullet--active");
				} else {
					element.classList.add("bl-apply-now__steps--hidden");
					_listItem.classList.add("bl-apply-now__bullets-container--bullet");
				}
				_listItem.innerHTML = "&bull;";

				_listItems.appendChild(_listItem);

				if (index < (this.steps.length - 1)) {
					const _listPipe = document.createElement('li');
					_listPipe.classList.add("bl-apply-now__bullets-container--bullet", "bl-apply-now__bullets-container--bullet--link");
					_listPipe.innerHTML = "&nbsp;";
					_listItems.appendChild(_listPipe);
				}
			});
		}
		if (this.wizardCount) {
			this.wizardCount.innerHTML = stepId + "/" + parseFloat(this.totalSteps.getAttribute('value'));
		}
		this.bulletContainer.innerHTML = "";
		this.bulletContainer.appendChild(_listItems);
		//this.updateForm(this.applicationType.value);
	}

	showNextStep(event) {
		const _target = event.currentTarget;
		const _currentStep = _target.closest("[data-step]");
		const _nextStep = _currentStep.getAttribute("data-step");
		if (this.wizardCount) {
			this.wizardCount.innerHTML = parseFloat(_nextStep) + 1 + "/" + parseFloat(this.totalSteps.getAttribute('value'));
		}
		this.showStep(parseFloat(_nextStep) + 1);
	}

	updateForm(type) {

		if (this.southAfricanIdField) {
			const _group = this.southAfricanIdField.closest(".form__group")
			if (type !== 'SOLE') {
				this.southAfricanIdField.classList.remove("form__input--required");
				_group.classList.add('form__group--hidden');

			} else {
				this.southAfricanIdField.classList.add("form__input--required");
				_group.classList.remove("form__group--hidden");
			}
		}

		if (this.businessFields) {
			this.businessFields.forEach(elem => {
				const _group = elem.closest(".form__group ");
				if (type !== 'SOLE') {
					elem.classList.add("form__input--required");
					_group.classList.remove("form__group--hidden");

				} else {
					elem.classList.remove("form__input--required");
					_group.classList.add('form__group--hidden');
				}
			});
		}
	}

	createElement(type, inputName, label, modifiers) {
		const _div = document.createElement('div');
		_div.classList.add("form__group");

		let _input;

		if (type == 'text') {
			const _label = document.createElement("label");
			_label.classList.add("form__label");
			_label.innerText = label;

			_input = document.createElement("input")
			_input.type = type;
			_input.name = inputName;
			_input.classList.add("form__input");
			_input.classList.add(...modifiers);

			_div.appendChild(_label);
			_div.appendChild(_input);
		}

		return _div;
	}

	createTextField(object) {
		let _group = document.createElement('div');
		_group.classList.add("form__group");
		_group.setAttribute("data-question", object.questionCode);

		let _wrapper = document.createElement('div');
		_wrapper.classList.add('apply-now__radio');

		let _label = document.createElement("label");
		_label.classList.add("form__label");
		_label.innerText = object.label;

		let _textBox = document.createElement("input");
		_textBox.classList.add("form__input", "form__input--required");
		_textBox.setAttribute("type", "text");
		_textBox.setAttribute("name", object.name);
		_textBox.setAttribute("value", "");
		// _textBox.setAttribute("placeholder", object.placeholder);

		_label.appendChild(_textBox);
		_wrapper.appendChild(_label);
		_group.appendChild(_wrapper);

		return _group;
	}

	createButton() {
		let _wrapper = document.createElement('div');
		_wrapper.classList.add("apply-now__buttons");

		let _button = document.createElement("button");
		_button.classList.add("button", "button--medium", "apply-now__button", "js_survey-button");
		_button.setAttribute("type", "button");
		_button.setAttribute("data-id", "link_content_survey button");
		_button.setAttribute("data-text", "home services | apply now | survey submit button click");
		_button.innerText = "Submit";

		_wrapper.appendChild(_button);

		return _wrapper;
	}

	actionForm(form: HTMLFormElement) {

		let _records = [];

		let name = Array.from(form.querySelectorAll('.form__success-container__firstname'));

		//Hidden fields
		let serviceType: any = form.querySelector("input[name=service-type]");
		let product: any = form.querySelector("input[name=product]");
		let email: any = form.querySelector("input[name=email]");
		let recipient: any = form.querySelector("input[name=recipient]");
		let description: any = form.querySelector("input[name=description]");
		let subject: any = form.querySelector("input[name=subject]");
		let redirect: any = form.querySelector("input[name=redirect]");


		let success = form.querySelector('.form__success--container');
		let error = form.querySelector('.form__error--container');

		// paremeters
		let _loanAmount: any = this.form.querySelector('input[name=loan-amount]');
		let _firstname: any = this.form.querySelector('input[name=first-name]');
		let _surname: any = this.form.querySelector('input[name=last-name]');
		let _contactNumber: any = this.form.querySelector('input[name=phone-number]');
		let _alternativeContactNumber: any = this.form.querySelector('input[name=alternative-number]');
		let _email: any = this.form.querySelector('input[name=email-address]');

		let _entityType: any = this.form.querySelector('select[name=entity-type]');
		let _businessName: any = this.form.querySelector('input[name=business-name]');
		let _idNumber: any = this.form.querySelector('input[name=sa-identity-number]');
		let _businessRegNumber: any = this.form.querySelector('input[name=business-reg-number]');
		let _businessDo: any = this.form.querySelector('input[name=business-do]');

		let _businessAccountCurrentlyHeld: any = this.form.querySelector('select[name=business-account]');
		let _accountNumber: any = this.form.querySelector('input[name=account-number]');
		let _turnOver: any = this.form.querySelector('input[name=turnover-tax]');
		let _purpose: any = this.form.querySelector('textarea[name=purpose]');

		let postData = '';

		if (_loanAmount) {
			postData += "&how-much-do-you-need=" + _loanAmount.value;
		}
		if (serviceType) {
			postData += "&service-type=" + serviceType.value;
		}

		if (_firstname) {
			postData += "&firstname=" + _firstname.value;
		}

		if (_surname) {
			postData += "&surname=" + _surname.value;
		}

		if (_contactNumber) {
			postData += "&contactNo=" + _contactNumber.value;
		}

		if (_alternativeContactNumber) {
			postData += "&altContactNo=" + _alternativeContactNumber.value;
		}

		if (_idNumber) {
			postData += "&saId=" + _idNumber.value;
		}

		if (_businessAccountCurrentlyHeld) {
			postData += "&bankName=" + _businessAccountCurrentlyHeld.value;
		}

		if (_accountNumber) {
			postData += "&bankAccountNo=" + _accountNumber.value;
		}

		if (_entityType) {
			postData += "&entityType=" + _entityType.value;
		}

		if (_businessName) {
			postData += "&businessName=" + _businessName.value;
		}

		if (_businessRegNumber) {
			postData += "&business-registration=" + _businessRegNumber.value;
		}

		if (_email) {
			postData += "&emailAddress=" + _email.value;
		}
		if (_businessDo) {
			postData += "&business-description=" + _businessDo.value;
		}

		if (_purpose) {
			postData += "&purpose=" + _purpose.value;
		}

		if (_turnOver) {
			postData += "&monthlyTurnOver=" + _turnOver.value;
		}

		if (description) {
			postData += "&description=" + description.value;
		}

		if (email) {
			postData += "&email=" + email.value;
		}

		if (recipient) {
			postData += "&recipient=" + recipient.value;
		}

		if (subject) {
			postData += "&subject=" + subject.value;
		}

		if (product) {
			postData += "&product=" + product.value;
		}

		if (redirect) {
			postData += "&redirect=" + redirect.value;
		}

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		this.formLoader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitGenericForm.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {

			this.formLoader.classList.remove('active');

			if (response.data === 'invalid') {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
				this.formLoader.classList.remove('active');
				this.formThankyou.classList.add('active');
				error.classList.add('active');
			} else {
				name.map((_item) => {
					_item.innerHTML = _firstname.value;
				});
				analyticsService.dtmFormComplete('complete', response.code);
				this.formLoader.classList.remove('active');
				this.formThankyou.classList.add('active');
				success.classList.add('active');
			}

		}).catch(response => {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			this.formLoader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');
		});
	}
}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-bl-apply-now/form-item-bl-apply-now.component.ts